import { useContext, useReducer } from "react";
import { Outlet } from "react-router-dom";
import { sourceReducer } from "./sourceReducer";
import { sourceInitialState } from "./sourceInitialState";
import SourceContext from "./SourceContext";


export const useSourceContext = () => useContext(SourceContext)


export function SourceProvider() {
    const [sourceState, sourceDispatch] = useReducer(
        sourceReducer,
        sourceInitialState
    )

    return (
        <SourceContext.Provider value={{ sourceState, sourceDispatch }}>
            <Outlet />
        </SourceContext.Provider>
    )
}
